import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Async Promotion",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-async-promotion",
    args: {
        url: "mock-data/promotions.json",
        id: "promo1",
        slider: false,
        random: true,
        maxItems: 1,
        mockData: true,
    },
    argTypes: {
        url: { control: "text" },
        id: { control: "text" },
        slider: { control: "boolean" },
        random: { control: "boolean" },
        maxItems: { control: "number" },
        mockData: { control: "boolean" },
    },
};

const Template = ({ id, url, slider, random, maxItems, mockData }) => {
    return html`
        ${slider
            ? html`
                  <div class="ux-u-opacity-0">
                      <ux-slider id="${id}">
                          <ux-slider-slide>
                              <img
                                  src="https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/6/f/csm_TruLaserTube-technology-special-tube-Keyvisual_52ad3b8997.jpg"
                              />
                          </ux-slider-slide>
                          <ux-slider-slide>
                              <img
                                  src="https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/6/f/csm_TruLaserTube-technology-special-tube-Keyvisual_52ad3b8997.jpg"
                              />
                          </ux-slider-slide>
                          <ux-slider-pagination
                              slot="pagination"
                              bottom-pagination
                          >
                          </ux-slider-pagination>
                      </ux-slider>
                  </div>
              `
            : html` <div id="${id}"></div> `}
        ${mockData
            ? html`
                  <ux-data-ingest data="${url}">
                      <ux-iws-async-promotion
                          target-selector="#${id}"
                          pick-items="${random ? "random" : "first"}"
                          max-items="${maxItems}"
                          output="${slider ? "slider" : "teaser"}"
                      ></ux-iws-async-promotion>
                  </ux-data-ingest>
              `
            : html`
                  <ux-iws-async-promotion
                      target-selector="#${id}"
                      pick-items="${random ? "random" : "first"}"
                      max-items="${maxItems}"
                      output="${slider ? "slider" : "teaser"}"
                      locale="de_DE"
                  ></ux-iws-async-promotion>
              `}
    `;
};

export const Default = Template.bind({});

export const Slider = Template.bind({});
Slider.args = {
    slider: true,
    random: false,
};

export const Empty = Template.bind({});
Empty.args = {
    url: "mock-data/promotions-empty.json",
};

export const Integration = Template.bind({});
Integration.args = {
    mockData: false,
};
